
(function ($, Drupal, drupalSettings, once) {
  'use strict';

  Drupal.behaviors.guideRequestform = {
    attach: function () {
      var $guideSignUp = $('.webform-submission-vacation-guide-form, .webform-submission-e-vacation-guide-form');

      // Frontend validation for guide request form.
      $(document).ready(function () {
        $guideSignUp.validate({
          rules: {
            'field_guide_email': {
              required: true,
              email: true
            },
            'field_guide_mailing_address[postal_code]': {
              required: {
                depends: function () {
                  // Check if this[required=required].
                  return $(this).prop('required');
                }
              }
            }
          },
          messages: {
            'field_guide_name[first]': 'First name is required.',
            'field_guide_name[last]': 'Last name is required.',
            'field_guide_email': 'Email is required and must be in a valid format.',
            'field_guide_mailing_address[country_code]': 'Country is required.',
            'field_guide_mailing_address[address_line1]': 'Street address is required.',
            'field_guide_mailing_address[locality]': 'Locality/City is required.',
            'field_guide_mailing_address[administrative_area]': 'State/Province is required.',
            'field_guide_mailing_address[postal_code]': 'Postal code is required.'
          }
        });

        // Select US upon loading the guide request form.
        var requestUrl = '//ipapi.co/json/';
        $.ajax({
          url: requestUrl,
          type: 'GET',
          success: function (json) {
            var country_code = json.country;
            $(once('change_country_code', '#edit-field-guide-mailing-address-0-address-country-code--2 > option')).val(country_code).change();
          },
          error: function (err) {
            $('#edit-field-guide-mailing-address-0-address-country-code--2 > option').val('US').change();
          }
        });
      });

    }
  };

})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef
